<template>
    <teleport to="body">
        <transition name="modal">
            <div class="modal-mask" @click="$emit('close')">
                <div class="modal-wrapper">
                    <div class="modal-container" @click.stop>

                        <div class="modal-header">
                            <slot name="header">
                            </slot>
                        </div>

                        <div class="modal-body">
                            <slot>
                            </slot>
                        </div>

                        <div class="modal-footer">
                            <slot name="footer">
                              <button class="modal-default-button butt" @click="$emit('close')">
                                OK
                              </button>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </teleport>
</template>

<script>
    export default {
        name: "Modal",
        emits: ['close'],
        components: {

        },
        data () {
            return {

            } 
        },
        computed: {

        },
        methods: {
            handleKeyPress (event) {
                if (event.key === 'Escape') {
                    this.$emit('close')
                }
            }
        },
        mounted () {
            window.addEventListener('keydown', this.handleKeyPress)
        },
        unmounted () {
            window.removeEventListener('keydown', this.handleKeyPress)
        }
    }
</script>

<style scoped lang="scss">
    #app {
        padding: 1rem;
    }

    .modal-mask {
        position: fixed;
        z-index: 9999;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .modal-container {
        text-align: left;
        display: inline-block;
        margin: 0px auto;
        padding: 20px 25px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        display: block;
        margin-top: 1rem;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    @media only screen and (max-width: 800px) {
        .modal-container {
            padding: 5px 5px;
            background-color: #fff;
        }
    }

</style>